module.exports = __webpack_public_path__ + "img/電気回路_5_4_2.3d47c60d.png";